import type { FolderData } from 'pages/MyDocuments/types';
import type { BasicSuccessResponse, HTTPFunctions } from '../types';

const folder = ({ get, post, put, del }: HTTPFunctions) => ({
  getFolder: (id: string) => get<FolderData>(`/folder/${id}`),
  getFolders: () => get<FolderData[]>('/folder/'),
  addFolder: (name: string) => post<FolderData>('/folder/', { name }),
  deleteFolder: (id: number) => del<BasicSuccessResponse>(`/folder/${id}`),
  setFolderNameById: (id: number, name: string) => put<BasicSuccessResponse>(`folder/${id}`, { name }),
  addDocumentToFolder: (documentId: string, folderId: number) =>
    post<BasicSuccessResponse>(`/folder/document/${folderId}/${documentId}`, {}),
});

export default folder;
